import { post } from '@/util/request'

export default {
    /**
     * 专题列表数据
     * @param query
     * @returns {*}
     */
    getKeywordList:query => post(`/keyword/list`,query),
    /**
     * 舆情走势图表数据接口
     * @param query
     * @returns {*}
     */
    getYqTrendPicList:query => post(`/keyword/trend`,query),
    /**
     * 舆情走势文字数据接口
     * @param query
     * @returns {*}
     */
    getYqTrendWordList:query => post(`/index/propertyTrend`,query),
    /**
     * 统计分析(来源分析、两微人物)
     * @param query
     * @returns {*}
     */
    getAnalyzeList:query => post(`/keyword/analyze`,query),
    /**
     * 专题舆情
     * @param query
     * @returns {*}
     */
    getTopicRankingList:query => post(`/index/topicRanking`,query),
    /**
     * 关键词云
     * @param query
     * @returns {*}
     */
    getWordCloudList:query => post(`/index/wordCloud`,query),
    /**
     * 统计分析导出
     * @param query
     * @returns {*}
     */
    exportStatistics:query => post(`/export/statistics`,query),


}
